__turbopack_context__.v({
  "carouselContainer": "PrizeRecommendationSection-module__nlRlya__carouselContainer",
});
